<template>
  <v-card light min-width="600px" class="pb-0">
    <v-card-title>
      Completa tus datos
      <v-btn text @click="overlay = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-subtitle>Podrás conseguir información sobre tu pedido y promociones para pedir online</v-card-subtitle>

    <v-card-text>
      <!--<div id="firebaseui-auth-container"></div>-->
      <v-container fluid class="mb-0">
        <v-row>
          <v-col cols="12" sm="4">
            <v-text-field outlined v-model="nombre" :label="this.$t('nombre')" required></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field outlined v-model="email" :label="this.$t('email')"></v-text-field>
          </v-col>
          <v-col cols="12" sm="2">
            <v-btn @click="guardarDatos" :loading="loadingPerfil" x-large class="success">
              <v-icon>mdi-check</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>

      <v-row justify="center">
        <v-btn class="ma-2" color="red" dark @click="authGoogle">
          ASOCIA TU CUENTA GOOGLE
          <v-icon dark right>mdi-google</v-icon>
        </v-btn>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
const firebase = require("firebase");
export default {
  data() {
    return {
      overlay: true,
      nombre: "",
      email: "",
      loadingPerfil: false
    };
  },
  computed: {
    /*nombreComputed:{
      get(){
        return this.$store.state.auth.user ?this.$store.state.auth.user.displayName : '';
      },
      set(v){
        this.nombre = v
      }
    },*/
  },
  watch: {
    "this.$store.state.auth.user.displayName"(v) {
      alert(v);
      this.nombre = v;
    },
    "this.$store.state.auth.user.email"(v) {
      alert(v);
      this.nombre = v;
    }
  },
  methods: {
    guardarDatos() {
      let _vm = this;
      _vm.loadingPerfil = true;
      this.$store
        .dispatch("auth/savePerfil", {
          displayName: this.nombre,
          email: this.email
        })
        .then(function(r) {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Perfil actualizado"
          });
        })
        .catch(e => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al actualizar el perfil: " + e
          });
        })
        .finally(function() {
          _vm.loadingPerfil = false;
        });
    },
    authGoogle() {
      let _vm = this;
      this.$store
        .dispatch("auth/authGoogle")
        .then(r => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Se ha asociado tu cuenta Google. Muchas Gracias"
          });
          _vm.overlay = false;
        })
        .catch(e => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al asociar tu cuenta Google"
          });
          console.log(e);
        });
    }
  },
  mounted() {
    if (this.$store.state.auth.isLogged) {
      this.nombre = this.$store.state.auth.user.displayName;
      this.email = this.$store.state.auth.user.email;
    }
    /*let ui = firebaseui.auth.AuthUI.getInstance();
    if (!ui) {
      ui = new firebaseui.auth.AuthUI(firebase.auth());
    }
    var uiConfig = {
      signInOptions: [
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.FacebookAuthProvider.PROVIDER_ID,

        firebase.auth.EmailAuthProvider.PROVIDER_ID
        /*
        {
          provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
          recaptchaParameters: {
            type: "image", // 'audio'
            size: "normal", // 'invisible' or 'compact'
            badge: "bottomleft" //' bottomright' or 'inline' applies to invisible.
          },
          defaultCountry: "GB", // Set default country to the United Kingdom (+44).
          // For prefilling the national number, set defaultNationNumber.
          // This will only be observed if only phone Auth provider is used since
          // for multiple providers, the NASCAR screen will always render first
          // with a 'sign in with phone number' button.
          defaultNationalNumber: "1234567890",
          // You can also pass the full phone number string instead of the
          // 'defaultCountry' and 'defaultNationalNumber'. However, in this case,
          // the first country ID that matches the country code will be used to
          // populate the country selector. So for countries that share the same
          // country code, the selected country may not be the expected one.
          // In that case, pass the 'defaultCountry' instead to ensure the exact
          // country is selected. The 'defaultCountry' and 'defaultNationaNumber'
          // will always have higher priority than 'loginHint' which will be ignored
          // in their favor. In this case, the default country will be 'GB' even
          // though 'loginHint' specified the country code as '+1'.
          loginHint: "+11234567890"
        }
      ]
    };*/
    //ui.start("#firebaseui-auth-container", uiConfig);
  }
};
</script>

<style>
.marginTop {
  margin-top: 210px;
}
.google-signin-button {
  color: white;
  background-color: red;
  height: 50px;
  font-size: 16px;
  border-radius: 10px;
  padding: 10px 20px 25px 20px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
</style>